"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toPromiseSnackbarState = void 0;
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var toPromiseSnackbarState = function (timerMilliSec, initialStateMapFn, delayedStateMapFn) { return function (source$) {
    return source$.pipe((0, operators_1.switchMap)(function (value) {
        return (0, rxjs_1.timer)(timerMilliSec).pipe((0, operators_1.mapTo)(delayedStateMapFn(value)), (0, operators_1.startWith)(initialStateMapFn(value)));
    }));
}; };
exports.toPromiseSnackbarState = toPromiseSnackbarState;
